const gql = String.raw

// Get the Primary Menu
export const PRIMARY_MENU_QUERY = gql`
  query PrimaryMenu {
    menu(id: "Signature - Primary Nav", idType: NAME) {
      slug
      menuItems {
        nodes {
          id
          url
          path
          label
          connectedNode {
            node {
              uri
            }
          }
        }
      }
    }
  }
`

// TODO: Make a generic menu query
// Get the Footer Menu & its childrens
export const FOOTER_MENU_QUERY = gql`
  query FooterMenu {
    menuItems(where: { location: FOOTER }, first: 100) {
      nodes {
        key: id
        parentId
        url
        path
        label
        # target
        connectedNode {
          node {
            uri
            # url
            # target
            # path
            # label
          }
        }
        title: label
      }
    }
  }
`

export const ALL_MENUS_QUERY = gql`
  query GetAllMenus {
    menus(first: 999) {
      nodes {
        id
        name
        slug
        acf {
          title
        }
        menuItems {
          nodes {
            id
            url
            path
            label
            target
            connectedNode {
              node {
                uri
              }
            }
          }
        }
      }
    }
  }
`
